import styled from 'styled-components';

const StyledFooter = styled.footer`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => theme.colors.primaryGray};
  box-shadow: 0px -4px 28px 0px rgba(89, 89, 89, 0.12);
  color: #363636;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  z-index: 2;
`;

export default StyledFooter;
